import { fetchCommercialBreadcrumbsSafe } from './fetchCommercialBreadcrumbsSafe';
import { IFetchCommercialBreadcrumbsParameters } from './types';
import { ICommercialBreadcrumbs } from '../../types/commercialBreadcrumbs';
import { IApplicationContext } from '../../types/applicationContext';

export const COMMERCIAL_BREADCRUMBS_FROM_SEO_SECTIONS_ENABLED_KEY = 'CommercialBreadcrumbs.FromSeoSections.Enabled';

export async function fetchCommercialBreadcrumbsIfNeeded(
  context: IApplicationContext,
  parameters: IFetchCommercialBreadcrumbsParameters,
  isCommercial: boolean,
): Promise<ICommercialBreadcrumbs | null> {
  if (!isCommercial) {
    return null;
  }

  if (!context.config.get<boolean>(COMMERCIAL_BREADCRUMBS_FROM_SEO_SECTIONS_ENABLED_KEY)) {
    return null;
  }

  return fetchCommercialBreadcrumbsSafe(context, parameters);
}
